import { soompi } from 'scripts/api/SoompiApi'
import { authRef, googleLogin, facebookLogin, session } from 'scripts/lib/firebase'
import { patch, put } from 'scripts/helpers/Utils'

const replaceImage = (info) => {
  return info.image.replace(/^data:image\/(png);base64,/, '')
}

const cleanData = (responses) => {
  let cleaner = []
  let data
  responses.forEach((response) => {
    data = {}
    data.id = response.id
    data.title = { text: response.title }
    data.images = {header: { url: response.image }}
    data.type = response.type
    data.slug = response.slug
    data.createdAt = response.createdAt
    cleaner.push(data)
    data = null
  })

  return cleaner
}

export default {
  clicked: (state) => {
    return { clicked: true }
  },

  unclick: (state) => {
    return { clicked: false }
  },

  initListingPosts: (state, actions, data) => {
    return {listings: {...data}}
  },

  listingPosts: async (state, actions, params) => {
    const {topicId, pageName, perPage, page, listSort} = params
    const {listings, clicked} = state
    const finalData = []
    const topic = await new Promise((resolve) => {
      let slugName = { 'fanclub': 'fanClub' }
      soompi.getTopic(slugName[pageName] || pageName)({ id: topicId }, { perPage: perPage, page: page, sort: listSort }).promise.then((topic) => {
        resolve(topic)
      })
    })
    const listKey = listSort ? `${topicId}-${listSort}` : topicId
    const posts = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].posts, ...topic.results] : topic.results
    finalData[listKey] = {topicId, page, posts, pageInfo: topic.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  listingFeed: async (state, actions, params) => {
    const {sort, perPage, page} = params
    const {listings, clicked} = state
    const finalData = []
    const feed = await new Promise(resolve => {
      soompi.getPostsBy(sort)({ page: page, perPage: perPage }).promise.then((feed) => {
        resolve(feed)
      })
    })
    const posts = (listings[`${sort}`] && !clicked) ? [...listings[`${sort}`].posts, ...feed.results] : feed.results
    finalData[sort] = {topicId: sort, page, posts, pageInfo: feed.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  authorPosts: async (state, actions, params) => {
    const {topicId, perPage, page, listSort} = params
    const {listings, clicked} = state
    const finalData = []
    const topic = await new Promise((resolve) => {
      soompi.getAuthorPosts({id: topicId}, {perPage, page, sort: listSort}).promise.then((topic) => {
        resolve(topic)
      })
    })
    const listKey = listSort ? `${topicId}-${listSort}` : topicId
    const posts = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].posts, ...topic.results] : topic.results
    finalData[listKey] = {topicId, page, posts, pageInfo: topic.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  search: async (state, actions, params) => {
    const {topicId, query, perPage, page, listSort} = params
    const {listings, clicked} = state
    const finalData = []
    const topic = await new Promise((resolve) => {
      soompi.getSearch({ query, page, perPage }).promise.then((topic) => {
        resolve(topic)
      })
    })
    const data = cleanData(topic.results)
    const listKey = listSort ? `${topicId}-${listSort}` : topicId
    const posts = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].posts, ...data] : data
    finalData[listKey] = {topicId, query, page, posts, pageInfo: topic.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  login: async (state, actions, params) => {
    const provider = params === 'google' ? googleLogin : facebookLogin
    const auth = await new Promise((resolve) => {
      authRef.signInWithPopup(provider).then((res) => {
        resolve(res)
      }).catch(e => {
        if (e.code !== 'auth/popup-closed-by-user') {
          alert(e.message)
        }
        resolve(false)
      })
    })
    const fandomAuth = await session.set(auth)
    const login = fandomAuth.auth === 'OK'
    return {auth: fandomAuth.auth, login, logout: false}
  },

  logout: async (state) => {
    const auth = await session.del()

    if (auth.auth === 'NO') {
      return {auth: 'NO', user: false, logout: true, login: false}
    } else {
      return state
    }
  },

  profile: async () => {
    const info = await session.get()
    return {auth: info.auth, user: Object.assign({...info.user}, {disqus: info.disqus ? info.disqus.SSO : null})}
  },

  updateProfile: async (state, actions, params) => {
    const user = {
      displayName: params.user.displayName,
      description: params.user.description
    }
    const update = await new Promise(resolve => {
      patch({
        url: 'users/profile/' + params.id,
        domain: '',
        headers: null,
        params: user
      }).then(({data}) => {
        if (data.update === 'OK' && params.user.hasImageToUpdate) {
          const image = replaceImage(params.user)
          put({
            url: 'users/profileimage/' + params.id,
            domain: '',
            headers: null,
            params: {
              image: image
            }
          }).then(({data}) => {
            resolve(data)
          })
        } else {
          resolve(data)
        }
      })
    })
    const info = await session.get()
    return {user: Object.assign({...info.user}, {...update}, {disqus: info.disqus ? info.disqus.SSO : null})}
  },

  setSection: (state, actions, data) => {
    return {section: data}
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/actions.js